import { createAsyncThunk } from "@reduxjs/toolkit";
import selfieDataRequest from "../utils/selfieDataRequest";
import { aceptTerms, getSelfie, saveSelfie, uploadSelfie } from "./api/selfie";

export const fetchUploadSelfie = createAsyncThunk(
  "selfie/setSelfieResponse",
  async (captured: string) => {
    try {
      if (captured) {
        const seflieDataRequest = selfieDataRequest(captured);
        const response = await uploadSelfie(seflieDataRequest);
        sessionStorage.setItem("vtoSelfieId", response?.data?.data?._id);
        return response?.data;
      }
    } catch (error: any) {
      console.log("error: ", error);
    }
  }
);

export const fetchSaveSelfie = createAsyncThunk(
  "selfie/save",
  async (selfieId: string | null) => {
    const response = await saveSelfie(selfieId);
    return response?.data;
  }
);

export const fetchGetSelfie = createAsyncThunk(
  "selfie/get",
  async (payload: { gti: string | null; atgId: string | null }) => {
    const response = await getSelfie(payload.gti, payload.atgId);
    return response?.data;
  }
);

export const fetchAcceptTerms = createAsyncThunk(
  "selfie/acceptTerms",
  async (payload: { gti: string | undefined; atgId: string | undefined }) => {
    const response = await aceptTerms(payload.gti, payload.atgId);
    return response?.data;
  }
);
